import create from 'utils/createReduxPromiseActionType'

export const ADD = create('posts/ADD')
export const LOAD = create('posts/LOAD')
export const LIKE = create('posts/LIKE')
export const REMOVE = create('posts/REMOVE')
export const PIN = create('posts/PIN')
